import React from 'react';
import { AnimatedSection } from '../../../lib/animations/AnimatedSection';

export default function QuoteCentered({ section, data, theme }) {
  const anim = section.animation || {};
  if (!data.quoteText) return null;

  return (
    <section className="px-5 py-16" data-testid="quote-section">
      <div className="max-w-sm mx-auto text-center">
        <AnimatedSection preset={anim.section || 'fade-in'}>
          <p
            className="text-base sm:text-lg leading-relaxed italic"
            style={{ color: theme.textPrimary, opacity: 0.8, fontFamily: theme.headingFont }}
          >
            "{data.quoteText}"
          </p>
          {data.quoteAuthor && (
            <p className="mt-4 text-xs tracking-wider" style={{ color: theme.textSecondary, fontFamily: theme.eyebrowFont }}>
              — {data.quoteAuthor}
            </p>
          )}
        </AnimatedSection>
      </div>
    </section>
  );
}
